import {
  BMI_30_CHECK,
  NAME_CHECK,
  NEXT_NAME,
  SHOW_IF_BMI_LESS_30
} from "config/tags";
import { OBESE_BMI } from "utils/eligibility";

export const clinicalRouting = ({
  nextUrlPath: nextUrlPathInit,
  question,
  assessment,
  routes,
  profile
}) => {
  let nextUrlPath = nextUrlPathInit;

  // Check if the user's BMI is 29.5 or lower. If so, show relevant questions.
  if (question.tags.includes(BMI_30_CHECK)) {
    if (profile.bmi <= OBESE_BMI) {
      const questionLess30Bmi = assessment.questions.find(q =>
        q.tags.includes(SHOW_IF_BMI_LESS_30)
      );
      nextUrlPath = routes.question(questionLess30Bmi.urlPath);
    }
  }

  if (window.ww.isTest) {
    return nextUrlPath;
  }

  // Skip first name question if we already have the user's first name.
  if (question.tags.includes(NAME_CHECK) && profile.firstName) {
    const nextName = assessment.questions.find(q => q.tags.includes(NEXT_NAME));
    nextUrlPath = routes.question(nextName.urlPath);
  }

  return nextUrlPath;
};
